import {
  SET_PAY_IN_FULL_DISABLED_FOR_REG_CHECKOUT,
  LOAD_CHECKOUT,
  UPDATE_SQUAD_QTY_FOR_REG_CHECKOUT,
  UPDATE_CART_TOTAL_FOR_REG_CHECKOUT,
  UPDATE_VIRTUAL_EVENT_QTY_FOR_REG_CHECKOUT,
  PROCESSING_STARTED,
  PROCESSING_FINISHED,
  SET_ALREADY_VALIDATED,
  CLEAR_PAYMENT,
  SET_TERMS_URL_FOR_REG_CHECKOUT,
  SET_AGREE_TO_TERMS_FOR_REG_CHECKOUT,
  SET_VALIDATION_MESSAGES_FOR_REG_CHECKOUT,
  CREATE_CHECKOUT_PAYMENT,
  SHOW_PAYMENT_DIALOG_EMBEDDED_FORM
} from './constants';

import {
  UPDATE_SCHEDULER_SQUAD_COUNT,
  UPDATE_SCHEDULER_VIRTUAL_EVENT_COUNT
} from 'shared/constants';

export const setPayInFullDisabled = disabled => ({
  type: SET_PAY_IN_FULL_DISABLED_FOR_REG_CHECKOUT,
  payload: disabled
});

export const loadCheckout = cart => ({
  type: LOAD_CHECKOUT,
  payload: cart
});

export const updateSquadQuantity = squad => ({
  type: UPDATE_SQUAD_QTY_FOR_REG_CHECKOUT,
  payload: squad
});

export const updateVirtualEventQuantity = virtualEvent => ({
  type: UPDATE_VIRTUAL_EVENT_QTY_FOR_REG_CHECKOUT,
  payload: virtualEvent
});

export const updateCartTotal = () => ({
  type: UPDATE_CART_TOTAL_FOR_REG_CHECKOUT
});

export const updateSchedulerSquadCount = (squad, count) => ({
  type: UPDATE_SCHEDULER_SQUAD_COUNT,
  payload: {
    squad: squad,
    count: count
  }
});
export const updateSchedulerVirtualEventCount = (virtualEvent, count) => ({
  type: UPDATE_SCHEDULER_VIRTUAL_EVENT_COUNT,
  payload: {
    virtualEvent: virtualEvent,
    count: count
  }
});

export const setProcessingStarted = () => ({
  type: PROCESSING_STARTED
});

export const setProcessingFinished = () => ({
  type: PROCESSING_FINISHED
});

export const setAlreadyValidated = payload => ({
  type: SET_ALREADY_VALIDATED,
  payload: payload
});

export const clearPayment = () => ({
  type: CLEAR_PAYMENT
});

export const setTermsUrl = payload => ({
  type: SET_TERMS_URL_FOR_REG_CHECKOUT,
  payload: payload
});

export const setValidationMessages = payload => ({
  type: SET_VALIDATION_MESSAGES_FOR_REG_CHECKOUT,
  payload: payload
});

export const setAgreeToTerms = payload => ({
  type: SET_AGREE_TO_TERMS_FOR_REG_CHECKOUT,
  payload: payload
});

export const createCheckoutPayment = payload => ({
  type: CREATE_CHECKOUT_PAYMENT,
  payload: payload
});

export const showPaymentDialogEmbeddedForm = () => ({
  type: SHOW_PAYMENT_DIALOG_EMBEDDED_FORM,
  payload: true
});

export const hidePaymentDialogEmbeddedForm = () => ({
  type: SHOW_PAYMENT_DIALOG_EMBEDDED_FORM,
  payload: false
});



// WEBPACK FOOTER //
// ./src/features/registration/checkout/actionTypes.js